import { Outlet } from 'react-router-dom';
import { WarehouseProvider } from 'components/Warehouse/context/WarehouseProvider';

const WarehouseWrapper = () => {
    return (
        <WarehouseProvider>
            <Outlet />
        </WarehouseProvider> 
    );
};

export default WarehouseWrapper;